import * as angular from 'angular';
import { downgradeInjectable } from '@angular/upgrade/static';
import {
  ExplorationService,
  NgxCookieService,
  SwitchViewClientService,
  DataRunClientService,
} from '@mode/shared/data-access-webapp';

export const DowngradedSharedDataAccessWebappModule = angular
  .module('downgraded-shared-data-access-webapp', [])
  .service('ExplorationService', downgradeInjectable(ExplorationService))
  .service('NgxCookieService', downgradeInjectable(NgxCookieService))
  .service('SwitchViewService', downgradeInjectable(SwitchViewClientService))
  .service('DataRunClientService', downgradeInjectable(DataRunClientService)).name;
